import { render, staticRenderFns } from "./InvestorMutualFundDetail.vue?vue&type=template&id=43be4378&scoped=true&"
import script from "./InvestorMutualFundDetail.vue?vue&type=script&lang=js&"
export * from "./InvestorMutualFundDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvestorMutualFundDetail.vue?vue&type=style&index=0&id=43be4378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be4378",
  null
  
)

export default component.exports